import { MessageDataType } from '../types'
import { store } from '../../../store'
import {
  updateSpotBadgeOrderAction,
  updateSpotBadgeTradeAction,
} from '../../../store/spot/actions'
import {
  updatePerpBadgeOrderAction,
  updatePerpBadgeTradeAction,
} from '../../../store/perp/actions'
import { WsOrderRecord } from './orders'

export function onMessageBadges(data: MessageDataType) {
  // Receive data from the server and update the badge on order tab
  switch (data.type) {
    // 'Order History' tab
    case 'order_filled':
    case 'order_failed':
    case 'order_cancelled': {
      const { status, tradeType } = data.data as WsOrderRecord
      // If message status is not 'PARTIAL_FILLED', update the badge on order history tab
      // 'PARTIAL_FILLED' has not been finalized, so the history list will not be updated
      if (status !== 'PARTIAL_FILLED') {
        if (tradeType === 'SPOTS') {
          // Show badge on order history tab
          store.dispatch(updateSpotBadgeOrderAction(true))
        } else if (tradeType === 'CONTRACTS') {
          store.dispatch(updatePerpBadgeOrderAction(true))
        }
      }
      break
    }
    // 'Trade History' tab
    case 'order_matched': {
      // Show badge on spot trade history tab
      store.dispatch(updateSpotBadgeTradeAction(true))
      break
    }
    case 'position_changed': {
      // Show badge on spot trade history tab
      store.dispatch(updatePerpBadgeTradeAction(true))
      break
    }
  }
}
